<mat-form-field
    #trigger="cdkOverlayOrigin"
    subscriptSizing="dynamic"
    class="st-address-form-field"
    cdkOverlayOrigin>
    <mat-label>{{ formattedAddressLabel() }}</mat-label>
    <input
        matInput
        class="st-address-form-field-input"
        [matAutocomplete]="auto"
        [value]="foormattedAddressValue()"
        [formControl]="internalFormControl"
        [required]="required()"
        [placeholder]="label() || placeholder()"
        (input)="searchForPlaces($event)"
        (focus)="onFocus($event)" />
    <button
        mat-icon-button
        matSuffix
        st-click-stop-propagation
        [disabled]="disabled()"
        (click)="isPanelOpen.set(true)">
        <mat-icon class="material-symbols-outlined">edit_location</mat-icon>
    </button>
    <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayWith"
        (optionSelected)="selectPrediction($event.option.value)">
        <mat-option
            *ngFor="let result of predictions()"
            class="st-address-form-item"
            [value]="result">
            <mat-icon class="material-symbols-outlined">place</mat-icon>
            <span class="st-address-form-title">
                <span class="st-address-form-title-matched">{{ result.structured_formatting.main_text }}</span>
                <span class="st-address-form-title-secondary">{{ result.structured_formatting.secondary_text }}</span>
            </span>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
<ng-template
    cdkConnectedOverlay
    st-click-stop-propagation
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isPanelOpen()"
    (overlayOutsideClick)="close()"
    (overlayKeydown)="onEscClick($event)">
    <div
        cdkTrapFocus
        cdkTrapFocusAutoCapture="true"
        class="st-address-form-details-fields"
        st-click-stop-propagation>
        <st-text-field
            class="st-address-form-details-fields-item"
            [value]="internalValue().streetAddress"
            [label]="streetAddressPlaceholder()"
            [placeholder]="streetAddressPlaceholder()"
            (changed)="internalAddressChanged($event)" />

        <st-text-field
            class="st-address-form-details-fields-item"
            [value]="internalValue().locationName"
            [label]="locationNamePlaceholder()"
            [placeholder]="locationNamePlaceholder()"
            (changed)="internalLocationChanged($event)" />

        <st-text-field
            [value]="internalValue().city"
            [label]="cityPlaceholder()"
            [placeholder]="cityPlaceholder()"
            (changed)="internalCityChanged($event)" />

        <st-text-field
            [value]="internalValue().state"
            [label]="statePlaceholder()"
            [placeholder]="statePlaceholder()"
            (changed)="internalStateChanged($event)" />

        <st-text-field
            [value]="internalValue().country"
            [label]="countryPlaceholder()"
            [placeholder]="countryPlaceholder()"
            (changed)="internalCountryChanged($event)" />
    </div>
</ng-template>
